let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5t0DK")).then(() => parcelRequire('1JGHk'));